"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = UISplitLayout;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _componentProp = require("../utils/propTypes/componentProp");

var _UIFlex = _interopRequireDefault(require("../layout/UIFlex"));

var _UIBox = _interopRequireDefault(require("../layout/UIBox"));

var _sizes = require("HubStyleTokens/sizes");

var Outer = (0, _styledComponents.default)(function (props) {
  var __orientation = props.orientation,
      rest = (0, _objectWithoutProperties2.default)(props, ["orientation"]);
  return _react.default.createElement("div", rest);
}).withConfig({
  displayName: "UISplitLayout__Outer",
  componentId: "sc-1kscu1b-0"
})(["padding-left:", ";width:100%;"], _sizes.BASE_SPACING_X);
var Inner = (0, _styledComponents.default)(_UIFlex.default).withConfig({
  displayName: "UISplitLayout__Inner",
  componentId: "sc-1kscu1b-1"
})(["margin-left:-", ";margin-top:-", ";"], _sizes.BASE_SPACING_X, _sizes.BASE_SPACING_Y);
var getSlotPadding = "\n  padding-left: " + _sizes.BASE_SPACING_X + ";\n  padding-top: " + _sizes.BASE_SPACING_Y + ";\n";
var PrimarySlot = (0, _styledComponents.default)(_UIBox.default).withConfig({
  displayName: "UISplitLayout__PrimarySlot",
  componentId: "sc-1kscu1b-2"
})(["", ";"], getSlotPadding);
var SecondarySlot = (0, _styledComponents.default)(_UIBox.default).withConfig({
  displayName: "UISplitLayout__SecondarySlot",
  componentId: "sc-1kscu1b-3"
})(["", ";"], getSlotPadding);

function UISplitLayout(props) {
  var InnerWrapper = props.InnerWrapper,
      orientation = props.orientation,
      Primary = props.Primary,
      primaryContent = props.primaryContent,
      primaryClassName = props.primaryClassName,
      primaryWidth = props.primaryWidth,
      reverseOrder = props.reverseOrder,
      Secondary = props.Secondary,
      secondaryContent = props.secondaryContent,
      secondaryClassName = props.secondaryClassName,
      secondaryWidth = props.secondaryWidth,
      rest = (0, _objectWithoutProperties2.default)(props, ["InnerWrapper", "orientation", "Primary", "primaryContent", "primaryClassName", "primaryWidth", "reverseOrder", "Secondary", "secondaryContent", "secondaryClassName", "secondaryWidth"]);
  var computedDirection = orientation === 'horizontal' ? 'row' : 'column';
  return _react.default.createElement(Outer, Object.assign({}, rest, {
    orientation: orientation
  }), _react.default.createElement(InnerWrapper, {
    direction: computedDirection,
    justify: "between",
    wrap: "wrap"
  }, _react.default.createElement(Primary, {
    className: primaryClassName,
    basis: primaryWidth,
    orientation: orientation,
    order: reverseOrder ? 1 : 0
  }, primaryContent), _react.default.createElement(Secondary, {
    basis: secondaryWidth,
    className: secondaryClassName,
    orientation: orientation
  }, secondaryContent)));
}

UISplitLayout.propTypes = {
  InnerWrapper: (0, _componentProp.getComponentPropType)(_UIFlex.default),
  orientation: _propTypes.default.oneOf(['horizontal', 'vertical']),
  Primary: (0, _componentProp.getComponentPropType)(_UIBox.default),
  primaryContent: _propTypes.default.node.isRequired,
  primaryClassName: _propTypes.default.string,
  primaryWidth: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
  reverseOrder: _propTypes.default.bool.isRequired,
  Secondary: (0, _componentProp.getComponentPropType)(_UIBox.default),
  secondaryContent: _propTypes.default.node,
  secondaryClassName: _propTypes.default.string,
  secondaryWidth: _propTypes.default.number,
  width: _propTypes.default.number
};
UISplitLayout.defaultProps = {
  InnerWrapper: Inner,
  Primary: PrimarySlot,
  Secondary: SecondarySlot,
  orientation: 'horizontal',
  reverseOrder: false
};
UISplitLayout.displayName = 'UISplitLayout';
module.exports = exports.default;